module.exports = __webpack_public_path__ + "7d088296/img/comments-icon.fdec7fdb.svg";